const routes = [
  {
    path: '/activityEnroll',
    name: '',
    redirect:'/activityEnroll/list'
  },
  {
    path: '/activityEnroll/list',
    name: '',
    meta:{
      module:'operate_manage',
      menu:'/activityEnroll/list',
      title:'活动报名管理',
      keepAlive: true,
      breadcrumb:['activityEnroll'],
      menuBreadcrumb: 'activityEnroll',
    },//menu 用于所属右侧菜单栏
    component: () => import('@/views/activityEnroll/list.vue'),
  },
  {
    path: '/activityEnroll/info',
    name: '',
    meta:{
      module:'operate_manage',
      menu:'/activityEnroll/info',
      title:'活动报名详情',
      breadcrumb:['activityEnroll','info'],
      menuBreadcrumb: 'info',
    },//menu 用于所属右侧菜单栏,breadcrumb用于面包屑
    component: () => import('@/views/activityEnroll/info.vue'),
  },
  {
    path: '/activityEnroll/preview',
    name: '',
    meta:{
      module:'operate_manage',
      menu:'/activityEnroll/preview',
      title:'活动报名预览',
      breadcrumb:['activityEnroll','preview'],
      menuBreadcrumb: 'preview',
    },//menu 用于所属右侧菜单栏,breadcrumb用于面包屑
    component: () => import('@/views/activityEnroll/preview.vue'),
  },
]

export default routes;
